export const FAQS = [
  {
    title: "Why is encryption important in storage clusters?",
    content:
      "Encryption protects sensitive data from unauthorized access, ensuring confidentiality and compliance with data protection regulations.",
  },
  {
    title: "How does encryption affect storage performance?",
    content:
      "While encryption adds some overhead due to the encryption and decryption processes, modern hardware and optimized software can minimize performance impacts.",
  },
  {
    title: "Can I use encrypted storage clusters in cloud environments?",
    content:
      "Yes, many cloud service providers offer encrypted storage solutions, allowing you to deploy secure storage clusters in the cloud.",
  },
  {
    title: "What types of encryption are commonly used in storage clusters?",
    content:
      "Common encryption methods include AES (Advanced Encryption Standard) with 256-bit keys, providing a strong level of security.",
  },
  {
    title: "How are encryption keys managed in storage clusters?",
    content:
      "Encryption keys can be managed using integrated key management systems or external services like Azure Key Vault, ensuring secure storage and access to keys.",
  },
  {
    title: "Is it possible to encrypt data in existing storage clusters?",
    content:
      "Yes, many storage solutions allow you to enable encryption on existing data, though this may require re-encryption processes and could involve downtime.",
  },
  {
    title: "How do encrypted storage clusters handle data redundancy?",
    content:
      "Encrypted storage clusters replicate encrypted data across multiple nodes, ensuring that redundancy does not compromise data security.",
  },
  {
    title: "Are there industry standards for encrypted storage clusters?",
    content:
      "Yes, standards like IEEE P1619 define encryption practices for storage media, ensuring interoperability and security.",
  },
  {
    title: "Can encrypted storage clusters protect against insider threats?",
    content:
      "While encryption secures data, implementing strict access controls and monitoring is essential to protect against insider threats.",
  },
  {
    title: "What are the best practices for managing encryption keys?",
    content:
      "Best practices include using hardware security modules (HSMs), regular key rotation, and implementing strict access controls to manage encryption keys securely.",
  },
];
